
import React from "react";
import { MonetizationPanel } from "@/components/monetization/MonetizationPanel";

export default function MonetizationPage() {
  return (
    <div className="py-4">
      <MonetizationPanel />
    </div>
  );
}
